import React from 'react';

const IdentityComponent = ({ children }: { children: React.ReactElement }) =>
    children;

export default IdentityComponent;
